import z from "zod";

export const assignVehicleCrewSchema = z.object({
	vehicleId: z.uuid(),
});

export type AssignVehicleCrewSchema = z.infer<typeof assignVehicleCrewSchema>;
